import { useMutation } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfTokenFormData } from 'utils/fetchWrapper';

interface CreateQuestionVariables {
  preparationTime?: number;
  questionText: string;
  questionType: string;
  responseTime: number;
  wordLimit?: number;
  video?: Blob;
}

interface CreateQuestionResponse {
  uid: string;
  preparation_time?: number;
  question_text: string;
  question_type: string;
  response_time: number;
  word_limit?: number;
  video?: Blob;
  question_uid: string;
}

const useCreateQuestion = (competencyUid: string) => {
  const {
    mutateAsync: createQuestion,
    data,
    isLoading,
    error,
  } = useMutation<CreateQuestionResponse, Error, CreateQuestionVariables>(
    ['createQuestion'],
    async ({
      preparationTime,
      questionText,
      questionType,
      responseTime,
      video,
      wordLimit,
    }) => {
      const body = new FormData();
      body.append('uid', competencyUid);
      body.append('question_text', questionText);
      body.append('question_type', questionType);
      body.append('response_time', `${responseTime}`);

      if (preparationTime)
        body.append('preparation_time', `${preparationTime}`);
      if (wordLimit) body.append('word_limit', `${wordLimit}`);
      if (video) body.append('video', video);

      const response = await fetchWithCsrfTokenFormData<CreateQuestionResponse>(
        `${PrependUrl.ASYNC}/questions/create`,
        'POST',
        body
      );

      return response;
    }
  );

  return {
    createQuestion,
    data,
    isLoading,
    error,
  };
};

export default useCreateQuestion;
